module.exports = __webpack_public_path__ + "img/icon-duanxin.7d19b486.svg";